import { Select } from '@mantine/core';
import { IFormInputSpecSelect } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a number input.
 */
export default function SelectInputPreview({ spec }: { spec: IFormInputSpecSelect }) {
  return <Select data={spec.options} required={spec.required} readOnly={spec.readOnly} searchable size="sm" />;
}
